import type { Locale } from "@/lib/i18n";
import { pl, type CShopTranslations } from "./pl";
import { en } from "./en";
import { de } from "./de";

export const cShopTranslations: Record<Locale, CShopTranslations> = {
  pl,
  en,
  de,
};

export type { CShopTranslations };
